import React, { Fragment } from 'react'
import { Link } from 'react-router-dom';

function Header(){
    return(
        <Fragment>
            {/* <!-- main header --> */}
            <header className="main-header header-style-three">
                    {/* <!-- header-top -->           
                    <!-- header-lower --> */}
                    <div className="auto-container">
                        <div className="header-lower">
                            <div className="outer-box">
                                <div className="logo-box">
                                    <figure className="logo"><Link to="/"><img src="assets/images/logo-4.png" alt="H.J. Enterprises"/></Link></figure>
                                </div>
                                <div className="menu-area">
                                    {/* <!--Mobile Navigation Toggler--> */}
                                    <div className="mobile-nav-toggler">
                                        <i className="icon-bar"></i>
                                        <i className="icon-bar"></i>
                                        <i className="icon-bar"></i>
                                    </div>
                                    <nav className="main-menu navbar-expand-md navbar-light clearfix">
                                        <div className="collapse navbar-collapse show clearfix" id="navbarSupportedContent">
                                            <ul className="navigation clearfix">
                                                <li><Link to={"/"} >Home</Link></li> 
                                                <li><Link to={"/loan"} >Loan</Link></li> 
                                                <li><Link to={"/insurance"} >Insurance</Link></li> 
                                                <li><Link to={"/mutualfund"} >Mutual Fund</Link></li> 
                                                <li><Link to={"/realestate"} >Real Estate</Link></li> 
                                                <li><Link to={"/aboutus"} >About us</Link></li> 
                                                <li><Link to={"/contactus"} >Contact</Link></li>                                             
                                            </ul>
                                        </div>
                                    </nav>
                                
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <!--sticky Header--> */}
                    <div className="sticky-header">
                        <div className="large-container">
                            <div className="outer-box">
                                <div className="logo-box">
                                    <figure className="logo"><Link to="/"><img src="assets/images/logo-4.png" alt="H.J. Enterprises"/></Link></figure>
                                </div>
                                <div className="menu-area">
                                    <nav className="main-menu clearfix">
                                        {/* <!--Keep This Empty / Menu will come through Javascript--> */}
                                    </nav>                            
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                {/* <!-- main-header end --> */}
        </Fragment>
    )
}

export default Header;